(window.Timeline = function (Behaviors) {

  "use strict";
  
  function Timeline(elem) {
    Behaviors.init(Timeline, this, arguments)

    this.timeline = this.$elem[0];

    window.addEventListener("scroll", ()=> {
        let t = this.timeline.getBoundingClientRect().top - 230,
            n = this.timeline.querySelector(".timeline__bar");
        n.style.display = "none";
        var i = function (e) {
            return e / (1 + Math.abs(e));
        };
        if (t < 0) {
            var l = (-1 * t) / this.timeline.scrollHeight,
                r = 2 * i(l) * 100;
            (n.style.display = "block"), (n.style.height = (r > 100 ? 100 : r) + "%");
        }
    });
  }

  Behaviors.inherit(Timeline, Behaviors.Behavior);
  Timeline.QUERY = '.timeline-list';

  Behaviors.register_behavior(Timeline);
  
  return Timeline;

  }(window.Behaviors));